import React, { useState } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { useRouteError } from 'react-router-dom';

import { Refresh } from '@mui/icons-material';
import { Button } from '@mui/material';

import { persistor, store } from '../state/store';

import './App.css';

export function ErrorPage() {
  const error: any = useRouteError();
  const hardRefresh = () => {
    store.dispatch({ type: 'RESET' });
    persistor.purge();
    window.history.replaceState(undefined, undefined, '/');
    window.location.reload();
  };

  const softRefresh = () => {
    window.history.replaceState(undefined, undefined, '/');
    window.location.reload();
  };

  return (
    <div className="error-page">
      <h1>Something went wrong...</h1>
      <p>
        <i>{error.statusText || error.message}</i>
      </p>
      <div>
        <Button className="retry-button" onClick={softRefresh}>
          <Refresh />
          Perform soft refresh (try first)
        </Button>
      </div>
      <div>
        <Button className="retry-button" onClick={hardRefresh} color="error">
          <Refresh />
          Perform hard refresh
        </Button>
      </div>
      <p className="error-stack-detail">{error.stack}</p>
    </div>
  );
}

export function ReactErrorBoundary({ children }: React.PropsWithChildren) {
  return (
    <ErrorBoundary
      FallbackComponent={ErrorPage}
      onError={(error, errorInfo) => {
        // log the error
        console.error(error);
        console.error(errorInfo);
      }}
      onReset={() => {
        // reloading the page to restore the initial state
        // of the current page
        console.log('reloading the page...');
        window.location.reload();

        // other reset logic...
      }}
    >
      {children}
    </ErrorBoundary>
  );
}

export function useCallbackWithErrorHandling(callback) {
  // eslint-disable-next-line
  const [state, setState] = useState();

  return (...args) => {
    try {
      callback(...args);
    } catch (e) {
      setState(() => {
        throw e;
      });
    }
  };
}

export function ErrorTrigger() {
  return (
    <Button
      onClick={useCallbackWithErrorHandling(() => (undefined as any).test)}
    >
      Break!
    </Button>
  );
}
